import { openModal } from "action/modal/openModal";
import { RootState } from "interfaces/generics.type";
import { useRouter } from "next/router";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import openLiveChat from "util/chat-widget/open-live-chat";
import { isBusinessHP } from "util/helper/helper";
import HeaderWrapper from "./HeaderWrapper";

function Header(props: any) {
  const { staticContent, actualResponse } = props;
  const { product, breadCrumbsV2 } = actualResponse || {};
  const { breadcrumbs } = staticContent || {};
  const {
    category, primaryCategory,
    openGuaranteedFitProductOverlay, partNumber,
  } = product || {};

  const breadCrumbProps = {
    category,
    primaryCategory,
    breadCrumbsV2,
    breadcrumbs,
    staticContent,
    partNumber,
    openGuaranteedFitProductOverlay,
  };
  const [showSlideMenu, setShowSlideMenu] = useState(false);

  const { asPath } = useRouter();
  const dispatch = useDispatch();

  const auth = useSelector((state: RootState) => state.authenticationState);

  const onClickLogin = (e: any) => {
    e.preventDefault();
    const isBusinessPage = isBusinessHP(asPath);
    dispatch(openModal("login", { ...(isBusinessPage && { title: "Welcome Back to Parts Avatar!", persistent: true }) }));
  };

  const onClickSignup = (e: any) => {
    e.preventDefault();
    dispatch(openModal("signup", {}));
  };

  const openSlideMenu = (e: any) => {
    e.preventDefault();
    setShowSlideMenu(true);
    if (!window.onGoogleLibraryLoad) {
      // import("component/login/LoginUtil")
      //   .then((module) => {
      //     module.googleLoginScriptHandler(true, auth.loggedIn, {
      //       refreshSession: (callback: any) => dispatch(refresh(callback)),
      //       showLoader: () => dispatch(showLoader()),
      //       hideLoader: () => dispatch(hideLoader()),
      //       closeModal: () => dispatch(closeModal()),
      //     });
      //   });
    }
  };

  const handleLiveChat = (e: any) => {
    e.preventDefault();
    openLiveChat();
  };

  return (
    <>
      <HeaderWrapper
        {...{
          auth,
          openSlideMenu,
          onClickLogin,
          onClickSignup,
          liveChat: handleLiveChat,
          onHideSlideMenu: () => setShowSlideMenu(false),
          showSlideMenu,
          breadCrumbProps,
        }}
      />
    </>
  );
}

export default Header;
